import {Component, EventEmitter, Output} from '@angular/core';
import {UntypedFormControl, Validators} from "@angular/forms";

@Component({
  selector: 'app-dropdown-quantity-selector',
  templateUrl: './dropdown-quantity-selector.component.html',
  styleUrls: ['./dropdown-quantity-selector.component.scss']
})
export class DropdownQuantitySelectorComponent {

  @Output() onSelectedQuantity = new EventEmitter<number>()

  customQuantityControl = new UntypedFormControl(null,[Validators.required, Validators.pattern('[0-9]*')])

  selectQuantity(quantity: number) {
    this.customQuantityControl.setValue(quantity);
    this.sendQuantity()
  }

  sendQuantity() {
    if(this.customQuantityControl.valid) {
      this.onSelectedQuantity.emit(this.customQuantityControl.value);
    }
  }

}
